module.exports = __webpack_public_path__ + "static/media/LK_white_Edit Content.f4b97a39.svg";